// **********************************************************
// Analytics: Consent Mode v2 + GA4 e-commerce dataLayer (GTM)
// Podatki izdelkov pridejo s strežnika (theme-includes/datalayer.php):
// localData.dl in atribut data-dl-item na karticah izdelkov in izdelkih v košarici.
// **********************************************************

window.dataLayer = window.dataLayer || [];

// *******************************************************************************
// Consent Mode v2
// Učinkovitost (performance_cookie) -> analytics_storage
// Trženje (marketing_cookie) -> ad_storage, ad_user_data, ad_personalization
// *******************************************************************************

window.prowConsent = (() => {
  // Ob spremembi kategorij piškotkov povečaj, da se banner obiskovalcem pokaže znova
  const version = '2';

  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }

  const has = (name) => Cookies.get(name) === 'true';

  const update = () => {
    const marketing = has('marketing_cookie') ? 'granted' : 'denied';
    gtag('consent', 'update', {
      analytics_storage: has('performance_cookie') ? 'granted' : 'denied',
      ad_storage: marketing,
      ad_user_data: marketing,
      ad_personalization: marketing,
    });
  };

  // Privzeto stanje mora biti v dataLayer pred nalaganjem GTM in pred vsemi dogodki
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });
  update();

  return { version, has, update };
})();

// *******************************************************************************
// dataLayer pomočniki
// *******************************************************************************

window.prowDL = (() => {
  const dl = (typeof localData !== 'undefined' && localData.dl) || {};

  // Dogodki se pošiljajo samo na produkciji; za preizkus drugje odpri stran z ?dl_debug=1
  try {
    if (new URLSearchParams(window.location.search).has('dl_debug')) {
      sessionStorage.setItem('dl_debug', '1');
    }
  } catch (e) {
    // sessionStorage ni na voljo
  }
  const enabled = (() => {
    try {
      return localData.env === 'production' || sessionStorage.getItem('dl_debug') === '1';
    } catch (e) {
      return localData.env === 'production';
    }
  })();

  const parseItem = (el) => {
    try {
      return JSON.parse(el.dataset.dlItem);
    } catch (e) {
      return null;
    }
  };

  const sum = (items) => Math.round(items.reduce((total, item) => total + (item.price || 0) * (item.quantity || 1), 0) * 100) / 100;

  const pushEcommerce = (event, ecommerce, extra = {}) => {
    if (!enabled || !ecommerce || !ecommerce.items || !ecommerce.items.length) return;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event, ...extra, ecommerce: { currency: 'EUR', ...ecommerce } });
  };

  const pushEvent = (data) => {
    if (enabled) window.dataLayer.push(data);
  };

  // Izdelek iz elementa (kartica, izdelek v košarici) ali s strani izdelka
  const itemFrom = (el) => {
    const source = el && el.closest('[data-dl-item]');
    return source ? parseItem(source) : dl.product && dl.product.item_id ? { ...dl.product } : null;
  };

  return { dl, enabled, parseItem, sum, pushEcommerce, pushEvent, itemFrom };
})();

// *******************************************************************************
// Uporabnik, prijava in registracija
// *******************************************************************************

if (window.prowDL.dl.user && window.prowDL.dl.user.user_id) {
  window.prowDL.pushEvent(window.prowDL.dl.user);
}

// Dogodek login / sign_up iz piškotka, ki ga nastavi strežnik ob prijavi ali registraciji
(() => {
  const raw = Cookies.get('prow_dl_event');
  if (!raw) return;
  Cookies.remove('prow_dl_event', { path: '/' });
  try {
    window.prowDL.pushEvent(JSON.parse(decodeURIComponent(raw)));
  } catch (e) {
    // neveljaven piškotek
  }
})();

// *******************************************************************************
// view_item
// *******************************************************************************

if (window.prowDL.dl.product && window.prowDL.dl.product.item_id) {
  const item = window.prowDL.dl.product;
  window.prowDL.pushEcommerce('view_item', { value: item.price, items: [item] });
}

// *******************************************************************************
// view_item_list: seznami izdelkov (kategorije, drsniki, iskanje); tudi kartice, dodane kasneje
// (filtri, »naloži več«). Vsaka kartica se pošlje le enkrat.
// *******************************************************************************

(() => {
  const seen = new WeakSet();
  const pageTitle = () =>
    (document.querySelector('h1') && document.querySelector('h1').textContent.trim()) || document.title;
  const listIndex = new Map();

  const listName = (section) => {
    const heading = section && section.querySelector('h2, .title, .section-header');
    const name = (section && section.matches('.sc-product-list') && pageTitle()) || (heading && heading.textContent.trim()) || pageTitle();
    return name.replace(/\s+/g, ' ').slice(0, 100);
  };
  const slug = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '');

  const pushLists = () => {
    const groups = new Map();
    document.querySelectorAll('[data-component="mol-product-card"][data-dl-item]').forEach((card) => {
      if (seen.has(card) || card.closest('.cart-view, .cart-popup')) return;
      seen.add(card);
      const section = card.closest('section[data-component]') || document.body;
      if (!groups.has(section)) groups.set(section, []);
      groups.get(section).push(card);
    });
    groups.forEach((cards, section) => {
      const name = listName(section);
      const id = slug(name);
      let index = listIndex.get(id) || 0;
      const items = cards
        .map((card) => window.prowDL.parseItem(card))
        .filter(Boolean)
        .map((item) => {
          const listItem = { ...item, index, item_list_id: id, item_list_name: name };
          index += 1;
          return listItem;
        });
      listIndex.set(id, index);
      window.prowDL.pushEcommerce('view_item_list', { item_list_id: id, item_list_name: name, items });
    });
  };

  pushLists();
  let timer;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(pushLists, 400);
  }).observe(document.body, { childList: true, subtree: true });
})();

// *******************************************************************************
// view_cart: ob odprtju stranske košarice (klic iz cart-popup.js)
// *******************************************************************************

window.prowDL.viewCart = (container) => {
  const items = [...container.querySelectorAll('[data-dl-item]')].map((el) => window.prowDL.parseItem(el)).filter(Boolean);
  window.prowDL.pushEcommerce('view_cart', { value: window.prowDL.sum(items), items });
};
